import React from 'react';

// Recognisable inline brand icons for the store availability row.
// Kept as small pure-SVG components (no extra deps).

export const WebIcon = ({ className = "w-3.5 h-3.5" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path d="M2 12h20M12 2c3 3 4 6 4 10s-1 7-4 10c-3-3-4-6-4-10s1-7 4-10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const GooglePlayIcon = ({ className = "w-3.5 h-3.5" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    {/* Simplified Google Play triangle in brand colours */}
    <path d="M3.5 2.2c-.3.2-.5.6-.5 1.1v17.4c0 .5.2.9.5 1.1l9.9-9.8L3.5 2.2z" fill="#00C1FF" />
    <path d="M17 8.9L13.4 6.7 3.5 2.2 13.4 12l3.6-3.1z" fill="#00D971" />
    <path d="M20.5 11.2l-3.5-2.3-3.6 3.1 3.6 3.1 3.5-2.3c1-.6 1-2 0-2.6z" fill="#FFBB00" />
    <path d="M3.5 21.8l9.9-9.8 3.6 3.1L3.5 21.8z" fill="#FF3946" />
  </svg>
);

export const AppleIcon = ({ className = "w-3.5 h-3.5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M16.365 1.43c0 1.14-.42 2.24-1.11 3.02-.74.84-1.94 1.48-2.99 1.4-.13-1.09.4-2.24 1.06-2.98.75-.83 2.04-1.44 3.04-1.44zM20.5 17.24c-.55 1.26-.81 1.82-1.51 2.94-.98 1.56-2.36 3.51-4.08 3.52-1.52.02-1.92-.99-3.99-.98-2.07.01-2.51 1-4.03.99-1.72-.01-3.03-1.76-4.01-3.32C.15 15.63-.13 10.5 2.19 7.79c1.66-1.93 4.28-3.06 6.74-3.06 2.5 0 4.08 1.36 6.15 1.36 2.01 0 3.24-1.37 6.13-1.37 2.19 0 4.5 1.19 6.15 3.24-5.41 2.96-4.53 10.7 2.14 9.28z" />
  </svg>
);

export const MicrosoftIcon = ({ className = "w-3.5 h-3.5" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <rect x="1" y="1" width="10" height="10" fill="#F35325" />
    <rect x="13" y="1" width="10" height="10" fill="#81BC06" />
    <rect x="1" y="13" width="10" height="10" fill="#05A6F0" />
    <rect x="13" y="13" width="10" height="10" fill="#FFBA08" />
  </svg>
);

export const GalaxyIcon = ({ className = "w-3.5 h-3.5" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
    {/* Stylised Galaxy Store — orbit + spark */}
    <ellipse cx="12" cy="12" rx="10" ry="4.5" stroke="currentColor" strokeWidth="2" transform="rotate(-25 12 12)" />
    <circle cx="12" cy="12" r="2.2" fill="currentColor" />
  </svg>
);
